import React, { useEffect, useState, useMemo } from 'react'
import { Grid } from '@material-ui/core'
import { useDispatch } from 'react-redux'

import { getCategoryList } from '_/modules/service-orders/actions'
import Button from '_/components/button'
import useModal from '_hooks/use-toggle'

import Accordion from '../../index'
import AccordionInfo from '../../accordion-info'

import useStyles from '../../styles'
import AddCategoryModal from '_components/modal/add-category-modal'

const AddSpecialSkills = ({ isProvider, isEditing, setValue, data }) => {
  const styles = useStyles()
  const dispatch = useDispatch()
  const [categoryList, setCategoryList] = useState()
  const [modalOpen, handleModal] = useModal()

  const parsedData = useMemo(() => {
    const sortById = []
    data?.forEach(item => sortById.push(item?.id))

    return sortById
  }, [data, categoryList])

  const handleSubmit = async formValues => {
    const payload = []

    await formValues.forEach(item => {
      const filteredCategory = categoryList.find(category => category?.id === item)

      if (filteredCategory) {
        payload.push({ id: filteredCategory?.id, name: filteredCategory?.name, icon: null })
      }
    })

    setValue(payload)
  }

  const handleDeleteSpecialSkills = catObj => {
    setValue(data.filter(currentCategory => currentCategory.id !== catObj.id))
  }

  useEffect(() => {
    dispatch(getCategoryList({})).then(res => setCategoryList(res))
  }, [])

  const handleAddSpecialSkills = () => {
    handleModal()
  }

  return (
    <Accordion
      id="especialidades-da-empresa-1"
      title="Especialidades"
      className={styles.containerAdd}
    >
      <Grid className={styles.userListAdd}>
        {data
          ?.sort((x, y) => (x.name < y.name ? -1 : 1))
          .map((specialSkills, index) => (
            <AccordionInfo
              // eslint-disable-next-line react/no-array-index-key
              key={specialSkills.value}
              isFirst={index === 0}
              values={specialSkills}
              isProvider={isProvider}
              isEditing={isEditing}
              handleDeleteValue={handleDeleteSpecialSkills}
            />
          ))}
      </Grid>
      {isEditing && (
        <Button
          className={styles.buttonAdd}
          variant="contained"
          color="primary"
          onClick={handleAddSpecialSkills}
        >
          +Adicionar registro
        </Button>
      )}
      {modalOpen && (
        <AddCategoryModal
          value={parsedData}
          patchCategories={handleSubmit}
          handleModal={handleModal}
          title="Especialidade"
          tradesmanCategories={data}
        />
      )}
    </Accordion>
  )
}

export default AddSpecialSkills
